import React, { Component } from 'react';
import { connect } from 'react-redux';

import ModalRoute from '../common/components/ModalRoute';

import { UserRoles } from '../user/user.constants';
import { getCurrentUser, getCurrentUserRole } from '../user/user.selectors';

import {
  ContentBlock,
  ContentSection,
  ModalContentBlock,
  PageHeader,
} from './components';

import { MyTransactionsBlock } from '../transaction/components';

import ChangePasswordFormContainer from '../user/components/ChangePasswordFormContainer';
import EditProfileFormContainer from '../user/components/EditProfileFormContainer';

import {Localize} from '../../locale/localization';

class ProfilePage extends Component {

  render() {
    const { currentUser, role } = this.props;
    const shouldRenderTransactions = currentUser.hasAccessToPrizeProgram && role !== UserRoles.SUPERUSER && role !== UserRoles.SALESMANAGER && role !== UserRoles.REGIONMANAGER;
    return (
      <div>
        <PageHeader title="Omat tietoni" />
          <ContentSection>
            {shouldRenderTransactions && (
              <MyTransactionsBlock title="Viimeisimmät myyntini" />
            )}
            <ContentBlock title="Omat tietoni">
              <EditProfileFormContainer />
            </ContentBlock>
          </ContentSection>
        <ModalRoute exact path="/profile/changePassword" parentPath="/profile">
          <ModalContentBlock title={Localize('password.update')}>
            <ChangePasswordFormContainer cancelPath="/profile" />
          </ModalContentBlock>
        </ModalRoute>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  const currentUser = getCurrentUser(state);
  const role = getCurrentUserRole(state);

  return {
    currentUser,
    role
  };
};

const ConnectedProfilePage = connect(
  mapStateToProps,
  null,
)(ProfilePage);


export default ConnectedProfilePage;


// WEBPACK FOOTER //
// ./src/modules/pages/ProfilePage.js